import React from 'react';
import ReactDOM from 'react-dom/client';
// Import global styles
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';
import router from './routes';

// Web3 imports
import '@rainbow-me/rainbowkit/styles.css';
import {
  RainbowKitProvider,
  darkTheme,
} from '@rainbow-me/rainbowkit';
import { WagmiConfig } from 'wagmi';
import { getWagmiConfig, chains } from './config/wallet';

// Import Demo Mode Provider
import { DemoModeProvider } from './context/DemoModeContext';
import DemoModeToggle from './components/common/DemoModeToggle';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Get the wagmi config - only initialize once
const config = getWagmiConfig();

// Remove loading screen once app is ready
const removeLoadingScreen = () => {
  const loadingScreen = document.querySelector('.loading-screen');
  if (loadingScreen) {
    // Add fade-out class if not already added
    if (!document.head.querySelector('#fade-out-style')) {
      const style = document.createElement('style');
      style.id = 'fade-out-style';
      style.textContent = `
        .fade-out {
          opacity: 0;
          transition: opacity 0.5s ease-out;
        }
      `;
      document.head.appendChild(style);
    }
    
    loadingScreen.classList.add('fade-out');
    setTimeout(() => {
      loadingScreen.remove();
    }, 500);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DemoModeProvider>
        <WagmiConfig config={config}>
          <RainbowKitProvider 
            chains={chains}
            theme={darkTheme({
              accentColor: '#32d432', // Primary green color
              accentColorForeground: 'white',
              borderRadius: 'large',
              fontStack: 'system',
              overlayBlur: 'small',
            })}>
              <RouterProvider router={router} />
              <Toaster 
                position="bottom-right" 
                toastOptions={{
                  style: {
                    background: '#1f2937',
                    color: '#fff',
                    border: '1px solid #374151',
                  },
                }}
              />
              <DemoModeToggle />
          </RainbowKitProvider>
        </WagmiConfig>
      </DemoModeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Remove loading screen after render is complete
setTimeout(removeLoadingScreen, 1000);